import React, { useContext, useEffect, useRef, useState } from "react";
import {
    Avatar,
    Button,
    Input,
    Modal,
    Space,
    Table,
    Tag,
    Tooltip,
    Typography,
} from "antd";
import {
    DeleteOutlined,
    EditOutlined,
    PlusOutlined,
    SearchOutlined,
} from "@ant-design/icons";
//api
import { http } from "../../services/httpService";
import config from "../../services/config.json";
import { context } from "../../context/context";
import { toast } from "react-toastify";
const TableData = () => {
    // search
    const [searchedColumn, setSearchedColumn] = useState("");
    const searchInput = useRef(null);
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
            close,
        }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`جستجو`}
                    value={selectedKeys[0]}
                    onChange={(e) =>
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={() =>
                        handleSearch(selectedKeys, confirm, dataIndex)
                    }
                    style={{
                        marginBottom: 8,
                        display: "block",
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        icon={<SearchOutlined />}
                        style={{
                            width: 90,
                        }}
                    >
                        جستجو
                    </Button>
                    <Button
                        onClick={() => {
                            handleReset(clearFilters);
                            handleSearch(selectedKeys, confirm, dataIndex);
                        }}
                        style={{
                            width: 90,
                        }}
                    >
                        حذف فیلتر
                    </Button>

                    <Button
                        type="link"
                        onClick={() => {
                            close();
                        }}
                    >
                        بستن
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? "#1677ff" : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            dataIndex === "tag"
                ? record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase())
                : record[dataIndex]
                      .toString()
                      .toLowerCase()
                      .includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) => (searchedColumn === dataIndex ? text : text),
    });
    const {
        placeCategories,
        setPlaceCategories,
        forceUpdate,
        setForceUpdate,
        setPlaceId,
        placeId,
        setPlaceName,
        setIsModalOpen,
        setIsEditShow,
        setPlaceTag,
        setPlaceIcon,
        setPlaceMapIcon,
        setPlaceColor,
        setIsAddSubset,
        child,
        setChild,
    } = useContext(context);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        setLoading(true);
        http.get(`${config.parkopoloApi}/api/Category/place`)
            .then((res) => {
                setLoading(false);
                setPlaceCategories(res.data.result);
            })
            .catch((err) => {
                setLoading(false);
                console.log(err);
            });
        setIsEditShow(false);
    }, [forceUpdate]);

    const [deleteModalOpen, setDeleteIsModalOpen] = useState(false);
    const deleteModal = () => {
        setDeleteIsModalOpen(true);
    };

    const handleDelete = (record) => {
        setPlaceId(record._id);
        deleteModal();
    };
    const handleAddSubset = (record) => {
        setIsAddSubset(true);
        setPlaceName("");
        setPlaceTag([]);
        setPlaceIcon("");
        setPlaceColor("#FFFFFF");
        setPlaceId(record._id);
        setIsModalOpen(true);
    };
    const handleDeleteConfirm = () => {
        setDeleteIsModalOpen(false);
        const parentId = placeCategories.map((p) => {
            if (p.children.includes(child)) return p._id;
        });

        placeCategories.find((p) => p._id === child._id)
            ? http
                  .delete(
                      `${config.parkopoloApi}/api/Category/category?categoryId=${placeId}`
                  )
                  .then((res) => {
                      setForceUpdate(4);
                      console.log(res.data.success);
                      toast.success(" دسته با موفقیت پاک شد !", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          progress: undefined,
                          theme: "colored",
                          style: { fontFamily: "Vazir" },
                      });
                  })
                  .catch((err) => {
                      console.log(err);
                      toast.error(" خطایی رخ داد !", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          progress: undefined,
                          theme: "colored",
                          style: { fontFamily: "Vazir" },
                      });
                  })
            : http
                  .delete(
                      `${config.parkopoloApi}/api/Category/subCategory?categoryId=${parentId}&subcategoryId=${child._id}`
                  )
                  .then((res) => {
                      setForceUpdate(12);
                      console.log(res.data.success);
                      toast.success(" زیردسته با موفقیت پاک شد !", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          progress: undefined,
                          theme: "colored",
                          style: { fontFamily: "Vazir" },
                      });
                  })
                  .catch((err) => {
                      console.log(err);
                      toast.error(" خطایی رخ داد !", {
                          position: "top-right",
                          autoClose: 5000,
                          hideProgressBar: false,
                          closeOnClick: true,
                          pauseOnHover: true,
                          progress: undefined,
                          theme: "colored",
                          style: { fontFamily: "Vazir" },
                      });
                  });
        setForceUpdate(58);
    };
    const handleCancel = () => {
        setDeleteIsModalOpen(false);
    };
    const handleEdit = (record) => {
        setPlaceName(record.name);
        setPlaceTag(record.tag);
        setPlaceIcon(record.icon);
        setPlaceMapIcon(record.icon);
        setPlaceColor(record.color);
        setPlaceId(record._id);
        setIsModalOpen(true);
        setIsEditShow(true);
    };
    const columns = [
        {
            title: "عنوان ",
            dataIndex: "name",
            key: "_id",
            ...getColumnSearchProps("name"),

            render: (text, { name }) => (
                <Typography.Link style={{ paddingLeft: "40px" }}>
                    {name}
                </Typography.Link>
            ),
        },
        {
            title: "آیکون",
            dataIndex: "icon",
            key: "icon",
            render: (icon, { color }) => {
                if (icon) {
                    return (
                        <i
                            className={`fa ${icon
                                .split(/(?=[A-Z])/)
                                .map((word) => word.toLowerCase())
                                .join("-")}`}
                            style={{ fontSize: "30px", color: `${color}` }}
                        />
                    );
                } else {
                    return null;
                }
            },
        },
        {
            title: "مپ آیکون",
            dataIndex: "mapIcon",
            key: "mapIcon",
            render: (icon, { color }) => {
                if (icon) {
                    return (
                        <i
                            className={`fa ${icon
                                .split(/(?=[A-Z])/)
                                .map((word) => word.toLowerCase())
                                .join("-")}`}
                            style={{ fontSize: "30px", color: `${color}` }}
                        />
                    );
                } else {
                    return null;
                }
            },
        },
        {
            title: "تگ",
            dataIndex: "tag",
            key: "tag",
            ...getColumnSearchProps("tag"),

            render: (_, { tag }) => (
                <>
                    {tag.map((t) => {
                        return <Tag key={t}>{t.toUpperCase()}</Tag>;
                    })}
                </>
            ),
        },
        {
            title: "عکس کاور",
            dataIndex: "coverPic",
            key: "coverPic",
            render: (_, { coverPic }) => (
                <Avatar
                    style={{
                        width: "40px",
                        height: "40px",
                    }}
                    src={<img src={coverPic?.address} alt="cover" />}
                />
            ),
        },
        {
            title: "عملیات",
            dataIndex: "button",
            width: "10%",
            key: "button",
            render: (text, record) => (
                <>
                    <Space style={{ width: "100%", direction: "ltr" }}>
                        <Button
                            onClick={() => {
                                return handleDelete(record);
                            }}
                            type="primary"
                            danger
                            shape="round"
                            icon={<DeleteOutlined />}
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        />
                        <Tooltip title="ویرایش">
                            <Button
                                onClick={() => {
                                    return handleEdit(record);
                                }}
                                type="primary"
                                icon={<EditOutlined />}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            />
                        </Tooltip>
                        {placeCategories.find((p) => p._id === record._id) ? (
                            <Tooltip title="اضافه کردن زیردسته جدید">
                                <Button
                                    onClick={() => {
                                        return handleAddSubset(record);
                                    }}
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                />
                            </Tooltip>
                        ) : null}
                    </Space>
                </>
            ),
        },
    ];
    const dataSource = placeCategories?.map((item) => ({
        ...item,
        key: item._id,
    }));

    const handleRowClick = (record) => {
        setChild(record);
    };

    return (
        <>
            <Table
                columns={columns}
                dataSource={dataSource}
                bordered
                loading={loading}
                style={{ marginTop: "15px" }}
                scroll={{ x: true }}
                size="small"
                pagination={{
                    pageSize: 10,
                    size: "default",
                    style: { position: "relative" },
                    showSizeChanger: false,
                }}
                onRow={(record) => {
                    return {
                        onClick: () => handleRowClick(record),
                    };
                }}
            />
            <Modal
                title="حذف کامل"
                open={deleteModalOpen}
                onOk={handleDeleteConfirm}
                onCancel={handleCancel}
                okText="حذف"
            >
                <p>مطمئنی میخوای حذف کنی؟</p>
            </Modal>
        </>
    );
};

export default TableData;
